export default {
    namespaced: true,
    state: {
        obj: {},
        objs: []
    },
    mutations: {
        setObjs(state, pload) {
            state.objs = pload
        },
        setObj(state, pload) {
            state.obj = pload
        },
    },
    actions: {
        getData({rootState}, {outlet_code, size, date}) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}bantuan?outlet_code=${outlet_code}&size=${size}&date=${date}`;
                this._vm.$axios.get(url,{headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response.data.data)
                    }, error => {
                        reject(error)
                    });
            })
        },
        save({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "bantuan"
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    })
            });
        }
    }
}